import {Injectable} from '@angular/core';
import {RestHttpService} from '@catcore/services/rest-http.service';
import {Restangular} from 'ngx-restangular';
import {EvidRevision} from "@catmodels/evid/types";

@Injectable()
export class EvidRevisionService extends RestHttpService<EvidRevision> {

  constructor(service: Restangular) {
    super('evid-revisions', service);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/evid/services/evid-revision.service.ts